import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["MvpLandingPage"] */ "/vercel/path0/src/components/hestiaDesign/MvpLandingPage/MvpLandingPage.tsx");
